/**
 * The browser's IANA time zone, the one thing the runtime keeps about where a
 * person is (edge ember/timezone.js). Rides every web turn and the sign-up
 * that starts in a browser. '' when the browser cannot say.
 */
export function browserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || '';
  } catch {
    return '';
  }
}
